export async function getAccessCodeSetInfo(request, ident) {
  const rv = await request({
    method: "get",
    url: "/access-code-set/" + ident,
  });
  return rv;
}

export async function provideAccessCode(request, payload) {
  const rv = await request({
    method: "post",
    url: "/access-codes/",
    data: payload
  });
  return rv;
}
